module.exports = __webpack_public_path__ + "static/media/DDsketch3.5e194445.png";